export default __webpack_public_path__ + "static/media/tvBg.c7b12d56.jpg";